import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PinpointAddSuccessPage } from './pinpoint-add-success.page';

const routes: Routes = [
  {
    path: '',
    component: PinpointAddSuccessPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PinpointAddSuccessPage]
})
export class PinpointAddSuccessPageModule {}
